<script>
    import Route, {router} from "../lib/Router/Router.svelte"
    import R, {LOADER} from "../lib/requests";
    import members from "../stores/members";
    import user from "../stores/user";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {copyObject, formatDate, scrollTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";
    import MemberPoints from "./MemberPoints.svelte";

    const tableColumns = [
        {key: 'code', title: 'CODE', sortable: true},
        {key: 'lastname', title: 'NAME', sortable: true, sort_way: 'ASC'},
        {key: 'email', title: 'EMAIL', sortable: true, class: 'hidden-xs'},
        {key: 'country_id', title: 'COUNTRY', sortable: true, class: 'hidden-xs'},
        {key: 'total_points', title: 'POINTS', sortable: true, class: 'hidden-xs'},
        {key: 'teatro_pass_expire_at', title: 'TEATRO', sortable: true, class: 'hidden-xs'},
        {key: 'last_checkin_at', title: 'LAST CHECKIN', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
        {key: '', title: ''},
    ];

    const itemsPerPage = [20, 50, 100, 500, 1000];

    let pageHeaderControls = [
        {id: 'create', name: 'NEW MEMBER', link: '/app/new-member', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            link: '/app/new-member',
            icon: 'plus-circle',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    let memberPoints = null;


    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            $members.list = result.list;
            $members.total = ~~result.total;

            $members.list.map(item => {
                if (!item.code) {
                    item.code = '';
                }
                if (!item.phone1) {
                    item.phone1 = '';
                }
                if (!item.last_subscription) {
                    item.last_subscription = '';
                }
            });
        }

        const onFailure = err => {
        };

        $members.search.offset = ($members.page - 1) * $members.search.limit;

        R.handle(R.member.index, $members.search, onSuccess, onFailure, loader);
    }

    const onSearch = () => {
        $members.page = 1;
        load();
    }

    const clearSearch = () => {
        members.clearSearch();
        $members.page = 1;
        load();
    }

    const onColumnSort = ({detail}) => {
        $members.search.sort_field = detail.key;
        $members.search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        $members.page = detail;
        load();
        scrollTo('listing-top', -50);
    }

    const onEdit = (member) => {
        $members.selectedId = member.id;
        $members.scrollY = window.scrollY;
        router.go(`/app/member/${member.id}`)();
    }

    const onDelete = (item) => {
        let name = (item.lastname + ' ' + item.firstname).trim();
        Alert.delete("Delete member", `You are about to delete member "${name}".\nAre you sure?`, () => deleteMember(item.id));
    }

    const deleteMember = id => {
        const onSuccess = result => {
            $members.list = $members.list.filter(x => x.id != result);
            Notifier.showMessage("Member deleted");
        }

        const onFailure = err => {
            // if (err.code) {
            //     if (err.code === 'object_related') {
            //         Alert.warning("Διαγραφή μέλους", `Το μέλος που θέλετε να διαγράψετε είναι συσχετισμένο με ${err.params.orders} παραγγελίες.\nΗ διαγραφή του μέλους δεν είναι δυνατή!`);
            //     }
            // }
        };

        R.handle(R.member.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onMemberPoints = item => {
        memberPoints = copyObject(item);
    }

    const closeMemberPoints = param => {
        memberPoints = null;
        if (param) {
            load();
        }
    }

    const initialize = () => {
        if (!$members.list) {
            $members.page = 1;
            $members.search.limit = itemsPerPage[0];

            load(LOADER.PAGE);
        } else if ($members.changed) {
            // order data changed from OrderEdit component
            load(LOADER.NONE);
            $members.changed = false;
        }

        if ($members.scrollY != null) {
            // set window scroll position to last edited transfer
            setTimeout(function () {
                window.scrollTo({top: $members.scrollY});
                $members.scrollY = null;
            }, 50);

        }
    }


    initialize();
</script>

<PageHeader title="Members" controls={ pageHeaderControls } on:reload={ load }/>
<div class="panel panel-simple p-2 mb-5">
    <div class="row">
        <div class="col-xl-2 col-lg-2 col-md-3 form-group-sm">
            <select class="form-select" bind:value="{ $members.search.status_id }" on:change={ onSearch }>
                <option value="">status</option>
                <option value="1">Active</option>
                <option value="2">Not active</option>
                <option value="3">Unverified</option>
            </select>
        </div>
        <div class="col-xl-4 col-lg-2 col-md-7 form-group-md form-group-sm">
            <input type="text" class="form-control" bind:value="{ $members.search.name }" on:change={ onSearch }
                   placeholder="name">
        </div>
        <div class="col-xl-4 col-lg-3 col-md-6 form-group-sm">
            <input type="text" class="form-control" bind:value="{ $members.search.email }" on:change={ onSearch }
                   placeholder="email">
        </div>
        <div class="col-xl-1 col-lg-1 col-md-3 col-6">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>CLEAR</button>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-3 col-6">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>SEARCH</button>
        </div>
    </div>
</div>

<div class="row align-items-center mb-4" id="listing-top">
    <div class="col-xl-2 col-lg-3 col-md-4 col-7">
        <select class="form-select form-select-sm" bind:value="{ $members.search.limit }" on:change="{ onSearch }">
            {#each itemsPerPage as item}
                <option value="{ item }">view { item } / page</option>
            {/each}
        </select>
    </div>
    {#if $members.list && $members.list.length}
        <div class="col-xl-10 col-lg-9 col-md-8 col-5">
            <span class="listing-info">Members: <strong>{ $members.total }</strong></span>
            <span class="listing-info hidden-xs">Page: <strong>{ $members.page }</strong></span>
        </div>
    {/if}
</div>

{#if $members.list}
    {#if $members.list.length}
        <table class="table table-list members-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each $members.list as item}
                <tr class="row-hover" class:row-selected="{ $members.selectedId === item.id }">
                    <td class="code-column">{item.code}</td>
                    <td>
                        <span class="is-link" class:not-active="{ item.status_id == 2 }"
                              on:click="{ () => onEdit(item) }">
                            { item.lastname } { item.firstname }
                        </span>
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.email }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.country_name }
                    </td>
                    <td class="points-column text-gray hidden-xs">
                        {#if item.total_points}
                            { item.total_points }
                        {/if}
                    </td>
                    <td class="date-column text-gray hidden-xs">
                        {#if item.teatro_pass_expire_at}
                            { formatDate(item.teatro_pass_expire_at, 'd-m-y') }
                        {/if}
                    </td>
                    <td class="date-column text-gray hidden-xs">
                        {#if item.last_checkin_at}
                            { formatDate(item.last_checkin_at, 'd-m-y') }
                        {/if}
                    </td>

                    <td class="button-column">
                        <button class="btn btn-action" title="member points" on:click="{ () => onMemberPoints(item) }">
                            <AppIcon icon="star"/>
                        </button>
                    </td>
                    {#if user.isAdmin()}
                        <td class="button-column">
                            <button class="btn btn-action" title="delete member" on:click="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </button>
                        </td>
                        <!--                        <td class="button-column" title="delete member"-->
                        <!--                            on:click="{ () => onDelete(item) }">-->
                        <!--                            <AppIcon icon="trash" size="16"/>-->
                        <!--                        </td>-->
                    {/if}
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ $members.search.limit }" totalItems="{ $members.total }" page="{ $members.page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel-simple panel-pad">
            No members found.
        </div>
    {/if}
{/if}

{#if memberPoints}
    <MemberPoints member="{ memberPoints }" closeCallback="{ closeMemberPoints }"/>
{/if}

<style>
    .members-list .not-verified {
        color: #777;
    }

    .code-column {
        width: 90px;
    }

    .points-column {
        width: 100px;
        text-align: right;
    }
</style>